import { render, staticRenderFns } from "./SaleLayoutEdit.vue?vue&type=template&id=12fc3c91"
import script from "./SaleLayoutEdit.vue?vue&type=script&lang=ts"
export * from "./SaleLayoutEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12fc3c91')) {
      api.createRecord('12fc3c91', component.options)
    } else {
      api.reload('12fc3c91', component.options)
    }
    module.hot.accept("./SaleLayoutEdit.vue?vue&type=template&id=12fc3c91", function () {
      api.rerender('12fc3c91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/sale/SaleLayoutEdit.vue"
export default component.exports